import useIsMobile from "@/hooks/useIsMobile";
import AuthorDetail from "@/screens/AuthorDetail";
import PageLayout from "@/screens/Layout/PageLayout";

const Index = ({
  authorDetail,
  latestStoryData,
  latestVideoData,
  authorPosts,
}) => {
  const isMobileDevice = useIsMobile();
  const metaCheck = authorDetail.seo_detail?.meta_title && authorDetail?.seo_detail?.meta_description && authorDetail?.seo_detail?.meta_keyword;
  if(!metaCheck){
    authorDetail.seo_detail = {...authorDetail.seo_detail,
      meta_title: `${authorDetail.title}: Read all the latest Hindi news from ${authorDetail.title} - Newstak`,
      meta_description: `${authorDetail.title} Latest News in Hindi: जानें ${authorDetail.title} की लिखी सबसे चर्चित खबरें, ग्राउंड कवरेज और वायरल स्टोरीज़ पढ़ें Newstak.in पर.`,
      meta_keyword: `${authorDetail.title}, ${authorDetail.title} news, Newstak author ${authorDetail.title}, ${authorDetail.title} articles, Newstak writers, ${authorDetail.title} रिपोर्ट्स` //english name missing
    }
  }
  return (
    <PageLayout
      latestStoryData={latestStoryData}
      latestVideoData={latestVideoData}
    >
      <AuthorDetail
        authorDetail={authorDetail}
        authorPosts={authorPosts}
        isMobileDevice={isMobileDevice}
      />
    </PageLayout>
  );
};

export default Index;

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let { slug } = ctx?.params;
    //* remove query param from url
    let authorUrl = "/author/" + slug;
    // authorUrl = authorUrl.split("?")[0];

    const { getDetailBySlug, getPostListByAuthorId } = await import(
      "../../handlers/author"
    );
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get redis api key for each api
    let authorDetailRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "reporterdetail", url: authorUrl },
    });
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let [authorDetail, latestStoryData, latestVideoData] = await Promise.all([
      fetchRedisWrapper(authorDetailRedisKey, () =>
        getDetailBySlug({ authorUrl })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
    ]);

    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    let authorId = authorDetail?.id ?? "";

    let authorPostListResult = await getPostListByAuthorId({
      authorId,
      page: page,
      display: 12,
    });

    let authorPosts = authorPostListResult?.content ?? [];

    if (!authorDetail || Object.keys(authorDetail).length === 0) {
      let slug = ctx?.params?.slug;
      return {
        // notFound: true,
        redirect: {
          destination: "/search/" + slug,
          statusCode: 301,
        },
      };
    }

    let headerCache = authorDetail?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);
    return {
      props: {
        authorDetail: authorDetail ?? null,
        authorPosts,
        latestStoryData,
        latestVideoData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
